import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Modal, ModalBody, ModalContent, ModalOverlay, Slide, Text } from '@chakra-ui/react';
import { FT_PI_AUTH0_LOGIN, FT_PIB_LOGIN_REDIRECT, GET_STATIC_CONTENT, SITE_LEISURE } from '@whitbread-eos/api';
import { BurgerMenu, ChevronRight, Icon } from '@whitbread-eos/atoms';
import { ManageBookingContainer } from '@whitbread-eos/molecules';
import { analytics, decodeIdToken, getAuthCookie, getLoggedInUserInfo, useAuthToken, useAuth0User, useRestQueryRequest, useUserData, useFeatureToggle, useAuth0Navigation, useCustomLocale, useQueryRequest } from '@whitbread-eos/utils';
import getConfig from 'next/config';
import { useEffect, useState } from 'react';
import { AuthContentManagerPIVariant } from '../../../../index';
import { getPibLoginRedirectUrl, getSecureTwoOrigin, isBusinessPage, useLogoutWithRedirect } from '../../helpers/helpers';
import AuthSideNav from './AuthSideNav';
import BusinessSideNav from './BusinessSideNav';
import DiscoverSideNav from './DiscoverSideNav';
import HeaderSideNav from './HeaderSideNav';
import LanguageSelectorSideNav from './LanguageSideNav';
import { renderLanguageItem } from './LanguageSideNav/LanguageSideNav.component';
import NavigationItem from './NavigationItem';
import { containerItemStyle } from './NavigationMenuMobile.style';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function NavigationMenuMobile(_ref) {
  var currentLanguage = _ref.currentLanguage,
    languagesList = _ref.languagesList,
    tickIcon = _ref.tickIcon,
    labels = _ref.labels,
    area = _ref.area;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalVisible = _useState2[0],
    setIsModalVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isManageBookingModalOpen = _useState4[0],
    setIsManageBookingModalOpen = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoginModalOpen = _useState6[0],
    setIsLoginModalOpen = _useState6[1];
  var _useState7 = useState('default'),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedSideNav = _useState8[0],
    setSelectedSideNav = _useState8[1];
  var _ref2 = getConfig() || {},
    _ref2$publicRuntimeCo = _ref2.publicRuntimeConfig,
    publicRuntimeConfig = _ref2$publicRuntimeCo === void 0 ? {} : _ref2$publicRuntimeCo;
  var _useUserData = useUserData(),
    isLoggedIn = _useUserData.isLoggedIn;
  var _useAuthToken = useAuthToken(),
    token = _useAuthToken.token,
    isAuth0TokenEnabled = _useAuthToken.isAuth0Enabled;
  var _useAuth0User = useAuth0User(isAuth0TokenEnabled),
    auth0User = _useAuth0User.user;
  var _useFeatureToggle = useFeatureToggle(),
    isAuth0Enabled = _useFeatureToggle[FT_PI_AUTH0_LOGIN],
    isPibLoginRedirectEnabled = _useFeatureToggle[FT_PIB_LOGIN_REDIRECT];
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useAuth0Navigation = useAuth0Navigation(),
    navigateToLogin = _useAuth0Navigation.navigateToLogin,
    navigateToLogout = _useAuth0Navigation.navigateToLogout;
  var _useQueryRequest = useQueryRequest(['GetStaticContent', language, country], GET_STATIC_CONTENT, {
      country,
      language,
      site: SITE_LEISURE,
      businessBooker: false
    }),
    headerInformationData = _useQueryRequest.data;
  var email = isAuth0TokenEnabled && auth0User !== null && auth0User !== void 0 && auth0User.email ? auth0User.email : decodeIdToken(getAuthCookie()).email;
  var _useRestQueryRequest = useRestQueryRequest(['userDetails', token], 'GET', "".concat(publicRuntimeConfig.NEXT_PUBLIC_REST_API, "/customers/hotels/").concat(email, "?business=false"), {
      Authorization: "Bearer ".concat(token)
    }, {
      enabled: isLoggedIn && !!email
    }),
    data = _useRestQueryRequest.data;
  var logout = useLogoutWithRedirect(country, language, !!isAuth0Enabled, navigateToLogout);
  useEffect(() => {
    var handleMessages = message => {
      if (message.origin === getSecureTwoOrigin()) {
        var _message$data;
        var action = typeof (message === null || message === void 0 ? void 0 : message.data) === 'string' ? message.data : (_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.action;
        if (action === 'userLoggedOut') {
          toggleSideNav('default');
        }
      }
    };
    window.addEventListener('message', handleMessages);
    return () => {
      window.removeEventListener('message', handleMessages);
    };
  }, []);
  var _getLoggedInUserInfo = getLoggedInUserInfo(token),
    isBusiness = _getLoggedInUserInfo.isBusiness;
  useEffect(() => {
    var _headerInformationDat;
    var businessDomain = headerInformationData === null || headerInformationData === void 0 || (_headerInformationDat = headerInformationData.headerInformation) === null || _headerInformationDat === void 0 || (_headerInformationDat = _headerInformationDat.content) === null || _headerInformationDat === void 0 || (_headerInformationDat = _headerInformationDat.authentication) === null || _headerInformationDat === void 0 || (_headerInformationDat = _headerInformationDat.login) === null || _headerInformationDat === void 0 || (_headerInformationDat = _headerInformationDat.business) === null || _headerInformationDat === void 0 ? void 0 : _headerInformationDat.businessDomain;
    if (isLoggedIn && isBusiness && businessDomain) {
      window.location.href = getPibLoginRedirectUrl(businessDomain, language, country);
    }
  }, [isLoggedIn, isBusiness, headerInformationData, language, country]);
  var toggleManageModal = () => {
    setIsManageBookingModalOpen(!isManageBookingModalOpen);
  };
  var toggleLoginModal = () => {
    setIsLoginModalOpen(!isLoginModalOpen);
  };
  var handleLoginClick = () => {
    var _headerInformationDat2;
    if (isPibLoginRedirectEnabled && isBusinessPage(window.location.pathname) && headerInformationData !== null && headerInformationData !== void 0 && (_headerInformationDat2 = headerInformationData.headerInformation) !== null && _headerInformationDat2 !== void 0 && (_headerInformationDat2 = _headerInformationDat2.content) !== null && _headerInformationDat2 !== void 0 && (_headerInformationDat2 = _headerInformationDat2.authentication) !== null && _headerInformationDat2 !== void 0 && (_headerInformationDat2 = _headerInformationDat2.login) !== null && _headerInformationDat2 !== void 0 && (_headerInformationDat2 = _headerInformationDat2.business) !== null && _headerInformationDat2 !== void 0 && _headerInformationDat2.businessDomain) {
      window.location.href = getPibLoginRedirectUrl(headerInformationData.headerInformation.content.authentication.login.business.businessDomain, language, country);
    } else if (isAuth0Enabled) {
      analytics.track('auth_sign_in_click', {
        authStep: 'sign_in_click'
      });
      navigateToLogin();
    } else {
      toggleLoginModal();
    }
  };
  var toggleSideNav = sideNav => {
    setSelectedSideNav(sideNav);
  };
  return _jsxs(Flex, {
    flexDir: "column",
    "data-testid": "mobile-navigation-menu",
    children: [_jsxs(Flex, _objectSpread(_objectSpread({}, burgerMenuContainerStyle), {}, {
      sx: {
        '@media print': {
          marginLeft: 'auto'
        }
      },
      onClick: () => {
        setIsModalVisible(true);
      },
      children: [_jsx(Icon, {
        _hover: {
          cursor: 'pointer'
        },
        svg: _jsx(BurgerMenu, {
          "data-testid": "burgerMenu"
        })
      }), _jsx(Text, _objectSpread(_objectSpread({
        margin: 0
      }, burgerMenuTextStyle), {}, {
        children: labels === null || labels === void 0 ? void 0 : labels.mobileMenuButton
      }))]
    })), _jsxs(Modal, {
      isOpen: isModalVisible,
      onClose: () => {
        setIsModalVisible(false);
      },
      size: "full",
      children: [_jsx(ModalOverlay, {
        zIndex: "var(--chakra-zIndices-banner)",
        "data-testid": "modalOverlay"
      }), _jsx(Slide, {
        direction: "left",
        in: isModalVisible,
        style: {
          zIndex: 'var(--chakra-zIndices-overlay)'
        },
        children: _jsx(ModalContent, _objectSpread(_objectSpread({}, modalContentStyle), {}, {
          "data-testid": "modalSideBar",
          children: renderSideNav(selectedSideNav)
        }))
      })]
    })]
  });
  function renderSideNav(selectedSideNav) {
    switch (selectedSideNav) {
      case 'default':
        {
          return renderDefaultSideBar();
        }
      case 'languageSelector':
        {
          var languageSelectorLabels = {
            language: labels.language
          };
          return _jsx(LanguageSelectorSideNav, {
            currentLanguage: currentLanguage,
            languagesList: languagesList,
            onClickHeaderTitle: () => toggleSideNav('default'),
            tickIcon: tickIcon,
            area: area,
            labels: languageSelectorLabels
          });
        }
      case 'auth':
        {
          var _data$contactDetail, _data$contactDetail2;
          return _jsx(AuthSideNav, {
            onClickHeaderTitle: () => toggleSideNav('default'),
            header: "".concat(data === null || data === void 0 || (_data$contactDetail = data.contactDetail) === null || _data$contactDetail === void 0 ? void 0 : _data$contactDetail.firstName, " ").concat(data === null || data === void 0 || (_data$contactDetail2 = data.contactDetail) === null || _data$contactDetail2 === void 0 ? void 0 : _data$contactDetail2.lastName),
            logout: logout,
            labels: labels
          });
        }
      case 'business':
        {
          return _jsx(BusinessSideNav, {
            labels: labels,
            onClickHeaderTitle: () => toggleSideNav('default')
          });
        }
      case 'discover':
        {
          return _jsx(DiscoverSideNav, {
            labels: labels,
            onClickHeaderTitle: () => toggleSideNav('default')
          });
        }
    }
  }
  function renderDefaultSideBar() {
    var _data$contactDetail3, _data$contactDetail4;
    return _jsxs(_Fragment, {
      children: [_jsx(HeaderSideNav, {}), _jsx(ModalBody, {
        p: "0",
        "data-testid": "defaultSideNav",
        children: _jsxs(Flex, {
          flexDir: "column",
          children: [_jsx(Box, {
            "data-testid": 'Global-TriggerLanguageSideNav',
            onClick: () => toggleSideNav('languageSelector'),
            children: renderLanguageItem({
              languagesList,
              locale: currentLanguage,
              icon: _jsx(Box, {
                pt: "0.37rem",
                pl: "sm",
                children: _jsx(Icon, {
                  svg: _jsx(ChevronRight, {})
                })
              }),
              withStyleHover: true
            })
          }), _jsxs(Flex, {
            bgColor: "lightGrey5",
            flexDir: "column",
            children: [!isLoggedIn ? _jsx(Box, _objectSpread(_objectSpread({
              onClick: handleLoginClick
            }, customContainerItemStyle), {}, {
              "data-testid": "Global-Login-Mobile",
              children: labels.logIn
            })) : !!(data !== null && data !== void 0 && data.contactDetail) && _jsx(Box, _objectSpread(_objectSpread({}, customContainerItemStyle), {}, {
              onClick: () => toggleSideNav('auth'),
              "data-testid": "Global-SideNav-UserName-NavItem-Mobile",
              children: _jsx(NavigationItem, {
                title: "".concat((_data$contactDetail3 = data.contactDetail) === null || _data$contactDetail3 === void 0 ? void 0 : _data$contactDetail3.firstName, " ").concat((_data$contactDetail4 = data.contactDetail) === null || _data$contactDetail4 === void 0 ? void 0 : _data$contactDetail4.lastName),
                icon: _jsx(Box, {
                  pt: "0.37rem",
                  pl: "sm",
                  children: _jsx(Icon, {
                    svg: _jsx(ChevronRight, {})
                  })
                })
              })
            })), _jsx(AuthContentManagerPIVariant, {
              isLoginModalOpen: isLoginModalOpen,
              toggleLoginModal: toggleLoginModal
            }), _jsxs(Box, _objectSpread(_objectSpread({}, customContainerItemStyle), {}, {
              onClick: toggleManageModal,
              "data-testid": 'Global-TriggerManageModal',
              children: [labels.findBooking, _jsx(ManageBookingContainer, {
                onClose: toggleManageModal,
                isOpen: isManageBookingModalOpen
              })]
            }))]
          }), _jsx(Box, _objectSpread(_objectSpread({}, customContainerItemStyle), {}, {
            "data-testid": 'Global-TriggerBusinessSideNav',
            onClick: () => toggleSideNav('business'),
            children: _jsx(NavigationItem, {
              title: labels.business,
              icon: _jsx(Box, {
                pt: "0.37rem",
                pl: "sm",
                children: _jsx(Icon, {
                  svg: _jsx(ChevronRight, {})
                })
              })
            })
          })), _jsx(Box, _objectSpread(_objectSpread({}, customContainerItemStyle), {}, {
            "data-testid": 'Global-TriggerDiscoverSideNav',
            onClick: () => toggleSideNav('discover'),
            children: _jsx(NavigationItem, {
              title: labels.discoverPI,
              icon: _jsx(Box, {
                pt: "0.37rem",
                pl: "sm",
                children: _jsx(Icon, {
                  svg: _jsx(ChevronRight, {})
                })
              })
            })
          }))]
        })
      })]
    });
  }
}
var customContainerItemStyle = _objectSpread(_objectSpread({}, containerItemStyle), {}, {
  _hover: {
    color: 'primary'
  }
});
var modalContentStyle = {
  borderRadius: 0,
  position: 'absolute',
  zIndex: 'var(--chakra-zIndices-overlay)',
  left: 0,
  display: {
    lg: 'none'
  },
  w: {
    mobile: '72',
    xs: '21.44rem',
    sm: '21.875rem',
    md: '23.25rem'
  }
};
var burgerMenuContainerStyle = {
  pt: '0.5rem',
  flexDir: 'column',
  justifyContent: 'center',
  alignItems: 'center'
};
var burgerMenuTextStyle = {
  pt: '0.375rem',
  fontSize: 'sm',
  lineHeight: '2',
  fontWeight: 'normal'
};